/**
 * Scroll the window to a section by element id.
 * Prefer window.scrollTo over Element.scrollIntoView — ancestors with
 * overflow:hidden (and transform from ScrollReveal) can make scrollIntoView
 * appear to do nothing.
 */
export function scrollToSection(id, offset = 55) {
  if (!id || typeof document === "undefined") return;

  const el =
    document.getElementById(id) ||
    // Header historically used "FAQ" while the section id is "faq"
    document.getElementById(String(id).toLowerCase()) ||
    document.getElementById(
      String(id).charAt(0).toUpperCase() + String(id).slice(1)
    );

  if (!el) {
    if (typeof window !== "undefined" && window.location.pathname !== "/") {
      window.location.assign(`/${id ? `#${id}` : ""}`);
    }
    return;
  }

  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({
    top: Math.max(0, top),
    behavior: "smooth",
  });
}
